import { Heading as Heading$1 } from '@shopify/ui-extensions/checkout';
import { createRemoteReactComponent } from '@remote-ui/react';

const Heading = createRemoteReactComponent(Heading$1);

export { Heading };
